module.exports = __webpack_public_path__ + "img/req-docs.b289fde5.svg";